<div class="grid-x">
  <!-- No need for this to show at the moment thus hidden = true -->
  <label for="report-selector-dropdown" [hidden]="true">
    <span>Select a Report Template:</span>
    <select (change)="onTemplateSelect($event.target.value)">
      @for (template of templates | async; track template) {
        <option [value]="template.id" [selected]="template.id === selectedTemplate.id">
          {{template.name}}
        </option>
      }
    </select>
  </label>
</div>
@if (selectedTemplate) {
  <div>
    @if (!selectedTemplate.contextValues?.length) {
      <div>No Configured Values.</div>
    }
    @for (contextValue of selectedTemplate.contextValues; track contextValue) {
      <div class="grid-x">
        <div class="cell small-5">
          <label class="label-text input-height">
            {{contextValue.context.displayName}}
          </label>
        </div>
        <div class="cell small-7">
          <div class="input-group">
            <input type="text" [ngModel]="contextValue.value" (ngModelChange)="onContextValueChange($event, contextValue.context.contextValue)" class="no-margin" />
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  Loading...
}
